import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "header", "title", "body", "frame"]

  connect() {
    this.onKeydown = this._onKeydown.bind(this)
    document.addEventListener("keydown", this.onKeydown)
    this.dragStartY = null
    this.currentTranslateY = 0
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  openFromElement(event) {
    const params = event.params || {}
    const url = params.url || event.currentTarget.dataset.sheetUrlParam
    const size = params.size || event.currentTarget.dataset.sheetSizeParam || "md"
    const title = params.title || event.currentTarget.dataset.sheetTitleParam || ""
    this.open({ url, size, title })
  }

  open({ url, size = "md", title = "" }) {
    // Set size
    this.containerTarget.className = "sheet-container sheet-" + size
    if (this.hasTitleTarget) this.titleTarget.textContent = title

    // Load URL into turbo frame
    if (url && this.hasFrameTarget) {
      this.frameTarget.src = url
    }

    this.element.classList.remove("hidden")
    requestAnimationFrame(() => {
      this.element.classList.add("sheet-open")
    })
    document.body.style.overflow = "hidden"
    this.dispatch("opened")
  }

  close() {
    this.element.classList.remove("sheet-open")
    document.body.style.overflow = ""
    setTimeout(() => {
      this.element.classList.add("hidden")
      if (this.hasFrameTarget) {
        this.frameTarget.innerHTML = '<div class="sheet-loading"><div class="sheet-spinner"></div></div>'
        this.frameTarget.removeAttribute("src")
      }
    }, 300)
    this.dispatch("closed")
  }

  dragStart(event) {
    this.dragStartY = event.touches[0].clientY
    this.containerTarget.style.transition = "none"
  }

  dragMove(event) {
    if (this.dragStartY === null) return
    const deltaY = event.touches[0].clientY - this.dragStartY
    if (deltaY > 0) {
      this.currentTranslateY = deltaY
      this.containerTarget.style.transform = `translateY(${deltaY}px)`
    }
  }

  dragEnd() {
    this.containerTarget.style.transition = ""
    if (this.currentTranslateY > 100) {
      this.close()
    } else {
      this.containerTarget.style.transform = ""
    }
    this.dragStartY = null
    this.currentTranslateY = 0
  }

  _onKeydown(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) {
      this.close()
    }
  }
}
